module.exports = __webpack_public_path__ + "static/media/AEC-final.7e8b5da6.jpg";